// /*--------------------------------------------------------------
// # Custom scripts for Blog Reel block
// --------------------------------------------------------------*/

var blogReelSlider = jQuery('.blog-reel-slider');
// slick slider settings
var blogReelSliderSettings = {
    mobileFirst: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span></button>',
    nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span></button>',
    responsive: [
        {
            breakpoint: 649,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
    ]
}

if (blogReelSlider.length > 0) {
    // set slides to same height
    blogReelSlider.on('setPosition', function () {
        jQuery(this).find('.blog-reel-slider__item').height('auto');
        var slickTrack = jQuery(this).find('.slick-track');
        var slickTrackHeight = jQuery(slickTrack).height();
        jQuery(this).find('.blog-reel-slider__item').css('height', slickTrackHeight + 'px');
    });

    // work out resize function to reinit or destroy slider on load and window resize
    jQuery(window).on('load resize', function() {        
        // init slider if not already initialised
        blogReelSlider.not('.slick-initialized').slick(blogReelSliderSettings);
    });

    // re init when in bootstrap tabbed content
    jQuery('[data-bs-toggle="tab"]').on('shown.bs.tab', function() {
        blogReelSlider.slick('setPosition');
    })
}
